import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import AddRTS from "@/pages/AddRTS";
import RTSRecords from "@/pages/RTSRecords";
import Reorders from "@/pages/Reorders";
import AfterSales from "@/pages/AfterSales";
import Reports from "@/pages/Reports";
import BranchAllStocks from "@/pages/BranchAllStocks";
import WalkInSales from "@/pages/WalkInSales";
import OnlineSales from "@/pages/OnlineSales";
import WarrantyTransactions from "@/pages/WarrantyTransactions";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";
import UserManagement from "@/pages/UserManagement";
import ActivityLogs from "@/pages/ActivityLogs";
import GlobalInventoryMatrix from "@/pages/GlobalInventoryMatrix";
import SalesAnalytics from "@/pages/SalesAnalytics";
import PurchaseRequest from "@/pages/PurchaseRequest";
import Receiving from "@/pages/Receiving";
import TransferLog from "@/pages/TransferLog";
import StockAudit from "@/pages/StockAudit";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Route - Login */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="add" element={<AddRTS />} />
              <Route path="records" element={<RTSRecords />} />
              <Route path="reorders" element={<Reorders />} />
              <Route path="after-sales" element={<AfterSales />} />
              <Route path="reports" element={<Reports />} />
              <Route path="inventory" element={<BranchAllStocks />} />
              <Route path="walk-in-sales" element={<WalkInSales />} />
              <Route path="online-sales" element={<OnlineSales />} />
              <Route path="warranty" element={<WarrantyTransactions />} />
              <Route path="analytics" element={<AnalyticsDashboard />} />
              <Route path="sales-analytics" element={<SalesAnalytics />} />
              <Route path="global-inventory" element={<GlobalInventoryMatrix />} />
              <Route path="purchase-request" element={<PurchaseRequest />} />
              <Route path="receiving" element={<Receiving />} />
              <Route path="transfers" element={<TransferLog />} />
              <Route path="admin/users" element={<UserManagement />} />
              <Route path="admin/activity-logs" element={<ActivityLogs />} />
              <Route path="admin/stock-audit" element={<StockAudit />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
